import * as z from "zod";

import { TeamMembershipSchema } from "./team-membership-model";

export const TeamSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  visibility: z.string(),
  logo: z.string().nullable().optional(),
  logoType: z.string().nullable().optional(),
  color: z.string().nullable().optional(),
  teamMembershipList: z.array(TeamMembershipSchema),
});

export type Team = z.infer<typeof TeamSchema>;
